import { render, staticRenderFns } from "./PeriodsList.vue?vue&type=template&id=60c02491"
import script from "./PeriodsList.vue?vue&type=script&lang=js"
export * from "./PeriodsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports